export const films = [
  {
    id: "night-ward-2023",
    title: "夜勤病栋",
    originalTitle: "Night Duty Ward",
    type: "电影",
    genres: ["悬疑", "惊悚", "医疗"],
    region: "日本",
    year: 2023,
    duration: "124分钟",
    director: "黑泽凉介",
    cast: ["佐藤健一", "中村由美", "高桥诚", "小林夏树"],
    rating: 8.7,
    views: 128400,
    tags: ["夜勤", "医院", "医疗事故", "二十年之谜"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20suspense%20film%20poster%20of%20an%20empty%20hospital%20corridor%20at%20midnight%2C%20flickering%20fluorescent%20light%2C%20teal%20blue%20tones%2C%20heavy%20atmosphere%2C%20fog%2C%20dramatic%20shadows%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-01&orientation=portrait",
    summary: "一栋在深夜里从不熄灯的旧医院，一场被掩盖了二十年的医疗事故，一位执意查清真相的夜班医生。",
    synopsis:
      "深夜十一点，青叶综合医院的老住院楼准时亮起走廊尽头的灯。新入职的夜班医生仓木凉太在例行查房时，发现七号病房的病历与住院登记存在无法解释的偏差。随着他逐一核对二十年前的旧档案，一桩被官方定性为『设备故障』的医疗事故重新浮出水面。院方的沉默、同事的回避、以及每到凌晨三点准时响起的呼叫铃，让凉太逐渐意识到——这栋病栋守着的秘密，远比死亡更沉重。影片以冷静克制的镜头语言和层层收束的悬念，勾勒出医疗体系阴影下普通人捍卫真相的艰难与勇气。"
  },
  {
    id: "night-ward-echoes",
    title: "夜勤病栋：暗夜回响",
    originalTitle: "Night Duty Ward: Echoes",
    type: "电影",
    genres: ["悬疑", "惊悚"],
    region: "日本",
    year: 2024,
    duration: "131分钟",
    director: "黑泽凉介",
    cast: ["佐藤健一", "中村由美", "渡边香织"],
    rating: 8.4,
    views: 96800,
    tags: ["续作", "回声", "录音带", "旧病栋"],
    cover: "https://readdy.ai/api/search-image?query=moody%20cinematic%20poster%20of%20a%20lone%20nurse%20silhouette%20walking%20down%20a%20dim%20hospital%20hallway%20at%20night%2C%20cold%20blue%20lighting%2C%20reflective%20wet%20floor%2C%20unsettling%20silence%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-02&orientation=portrait",
    summary: "一盘被遗忘在储物间的旧录音带，录下了二十年前那晚真实的抢救现场。",
    synopsis:
      "在《夜勤病栋》故事结束的三年后，已经成为主治医师的仓木凉太收到一个匿名包裹，里面是一盘标着『03:00』的旧式录音带。录音里，二十年前的抢救现场、值班医生的争执、以及一个不该出现在场的声音被一一还原。为了验证录音真伪，凉太重返已经停用的旧住院楼，却发现有人比他更早抵达，也更不希望真相被听见。续作在保留冷峻气质的同时，将叙事重心从『发生了什么』转向『谁在阻止真相被听见』，悬念密度进一步升级。"
  },
  {
    id: "night-ward-s2",
    title: "夜勤病栋 第二季",
    originalTitle: "Night Duty Ward Season 2",
    type: "电视剧",
    genres: ["悬疑", "剧情", "医疗"],
    region: "日本",
    year: 2024,
    duration: "全12集",
    director: "田边和树",
    cast: ["佐藤健一", "中村由美", "森田爱", "石井悟"],
    rating: 9.0,
    views: 214500,
    tags: ["单元剧", "夜班群像", "医院", "季播"],
    cover: "https://readdy.ai/api/search-image?query=dark%20cinematic%20poster%20of%20an%20old%20hospital%20building%20exterior%20at%20night%2C%20single%20lit%20window%2C%20heavy%20rain%2C%20deep%20blue%20and%20grey%20tones%2C%20ominous%20atmosphere%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-03&orientation=portrait",
    summary: "十二个夜班，十二段发生在凌晨的故事，串起一座城市医院最真实的深夜切片。",
    synopsis:
      "第二季将镜头从单一案件扩展到整座医院的夜班群像。每一集聚焦一个夜班，讲述急诊、ICU、产科、太平间等不同岗位上真实而克制的深夜故事：一个等待器官捐献的年轻人、一位坚持为无主病人署名的护士、一名在辞职与坚守之间挣扎的实习医生。看似独立的故事之间，暗藏着一条关于医院管理层的隐秘线索，直到季终才完全收束。剧集以扎实的医疗细节与温柔而冷静的叙事，成为当季口碑最高的剧集之一。"
  },
  {
    id: "shadowless-lamp",
    title: "无影灯下",
    originalTitle: "Beneath the Shadowless Lamp",
    type: "电影",
    genres: ["剧情", "医疗"],
    region: "韩国",
    year: 2022,
    duration: "118分钟",
    director: "朴振浩",
    cast: ["李尚勋", "金敏书", "崔都贤"],
    rating: 8.1,
    views: 74300,
    tags: ["手术", "医患", "抉择", "写实"],
    cover: "https://readdy.ai/api/search-image?query=dramatic%20surgical%20lamp%20glowing%20in%20a%20darkened%20operating%20room%2C%20cinematic%20thriller%20poster%2C%20blue%20grey%20palette%2C%20heavy%20shadow%2C%20sterile%20instruments%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-04&orientation=portrait",
    summary: "当无影灯亮起，主刀医生必须在规则、良知与生命之间做出唯一一次选择。",
    synopsis:
      "一次常规的夜班急症手术中，主刀医生姜仁浩发现患者的伤情与病历记载严重不符。在手术台前有限的十几分钟里，他必须决定是严格遵循流程等待上级授权，还是冒着职业风险立即施救。影片几乎全部发生在手术室与走廊之间，依靠密集的对话与克制的特写，把医疗现场那种拉满的紧张感呈现得淋漓尽致。结尾并不提供廉价的答案，而是把选择本身留给观众。"
  },
  {
    id: "ward-seven",
    title: "第七号病房",
    originalTitle: "Room No.7",
    type: "电影",
    genres: ["悬疑", "恐怖"],
    region: "日本",
    year: 2021,
    duration: "106分钟",
    director: "冈本诗织",
    cast: ["高桥诚", "石井悟", "渡边香织"],
    rating: 7.6,
    views: 58200,
    tags: ["病房", "旧楼", "禁区", "传闻"],
    cover: "https://readdy.ai/api/search-image?query=closed%20door%20of%20hospital%20room%20number%20seven%2C%20dim%20corridor%20light%2C%20mysterious%20suspense%20film%20poster%2C%20cold%20blue%20grey%20tones%2C%20peeling%20paint%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-05&orientation=portrait",
    summary: "旧病栋东侧的第七号病房长年上锁，所有住进去的人，都没有活着出来。",
    synopsis:
      "实习护士小林夏树被分配到几乎无人问津的旧病栋值班。前辈只留下一句叮嘱：『第七号病房的门，无论听到什么都不要打开。』然而当夜，呼叫铃一次次从那个方向响起。随着她翻阅住院记录，一段被院方刻意抹去的往事逐渐拼合——原来所谓『禁区』，锁住的从来不是病人。影片用极少的对白与大量的环境音，营造出令人屏息的压抑感，是近年来最受讨论的旧楼题材作品之一。"
  },
  {
    id: "night-nurse",
    title: "夜班护士",
    originalTitle: "The Night Nurse",
    type: "电视剧",
    genres: ["剧情", "医疗"],
    region: "中国",
    year: 2023,
    duration: "全10集",
    director: "陆文轩",
    cast: ["周雨桐", "韩志远", "林书瑶"],
    rating: 8.3,
    views: 103900,
    tags: ["护理", "夜班", "成长", "群像"],
    cover: "https://readdy.ai/api/search-image?query=night%20shift%20nurse%20station%20interior%2C%20empty%20desk%20with%20dim%20desk%20lamp%2C%20cinematic%20moody%20photograph%2C%20blue%20grey%20tones%2C%20paper%20charts%20and%20clipboard%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-06&orientation=portrait",
    summary: "一个刚从护校毕业的年轻人，在连续十个夜班里学会什么叫真正的照顾。",
    synopsis:
      "护校毕业生沈知微被分配到市医院急诊科，开始了她人生中第一段夜班生涯。十集故事对应十个夜班，从最初的手忙脚乱、被家属误解，到逐渐学会在有限的资源与人手之间做出判断，她与同期入职的同事、经验丰富的老护士长共同成长。剧集不回避护理工作的琐碎与艰辛，也用大量温暖的细节提醒观众：深夜的医院里，总有人替这座城市守着灯。"
  },
  {
    id: "midnight-er",
    title: "深夜急诊室",
    originalTitle: "Midnight ER",
    type: "电视剧",
    genres: ["剧情", "医疗"],
    region: "美国",
    year: 2020,
    duration: "全8集",
    director: "David Coleman",
    cast: ["Ryan Pierce", "Amelia Boone", "Grace Lin"],
    rating: 7.9,
    views: 61900,
    tags: ["急诊", "长镜头", "真实时间", "夜班"],
    cover: "https://readdy.ai/api/search-image?query=busy%20hospital%20emergency%20room%20at%20midnight%2C%20blurred%20motion%20of%20staff%2C%20cold%20fluorescent%20lighting%2C%20cinematic%20medical%20drama%2C%20blue%20tones%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-07&orientation=portrait",
    summary: "一个夜班，八个小时，镜头没有离开过急诊室一步。",
    synopsis:
      "剧集采用近乎实时的叙事结构，每一集都只讲述一个完整夜班里发生的事。从凌晨零点的第一辆救护车，到清晨六点交班前的最后一台抢救，急诊室的每一分钟都被挤压出紧绷的戏剧张力。医护们在资源紧张、人手不足的现实里疲于奔命，却仍要在每一次分诊中做出近乎残酷的取舍。写实的镜头语言与高度专业的医疗顾问团队，让这部剧收获了『最接近真实急诊室』的评价。"
  },
  {
    id: "silent-corridor",
    title: "静默走廊",
    originalTitle: "The Silent Corridor",
    type: "电影",
    genres: ["悬疑", "惊悚"],
    region: "韩国",
    year: 2022,
    duration: "112分钟",
    director: "朴振浩",
    cast: ["金敏书", "崔都贤", "李尚勋"],
    rating: 8.0,
    views: 69400,
    tags: ["走廊", "监控", "失踪", "心理"],
    cover: "https://readdy.ai/api/search-image?query=long%20silent%20hospital%20corridor%20vanishing%20into%20darkness%2C%20single%20ceiling%20light%2C%20suspense%20atmosphere%2C%20cold%20blue%20palette%2C%20empty%20wheelchair%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-08&orientation=portrait",
    summary: "监控录像显示，她走进那条走廊后再也没有出来——可那条走廊只有一个出口。",
    synopsis:
      "一名住院患者在深夜走出病房后离奇失踪，医院监控清晰记录她走进东侧走廊的全过程，却没有任何她离开的画面。负责调查的刑警发现，这条走廊的摄像头恰好存在一个几秒钟的盲区，而这段时间里共有七名医护人员经过。随着调查深入，一场关于伪装与共谋的精密布局被逐层揭开。影片以冷峻的空间调度与近乎强迫症般的逻辑推演，让观众与侦探一同在有限的线索中逼近真相。"
  },
  {
    id: "midnight-rounds",
    title: "午夜查房",
    originalTitle: "Midnight Rounds",
    type: "电影",
    genres: ["剧情", "悬疑"],
    region: "日本",
    year: 2019,
    duration: "98分钟",
    director: "冈本诗织",
    cast: ["高桥诚", "小林夏树", "森田爱"],
    rating: 7.4,
    views: 42700,
    tags: ["查房", "夜班医生", "独白", "病房"],
    cover: "https://readdy.ai/api/search-image?query=doctor%20holding%20clipboard%20walking%20at%20night%20in%20a%20hospital%20ward%2C%20back%20view%20silhouette%2C%20dim%20blue%20light%2C%20cinematic%20medical%20suspense%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-09&orientation=portrait",
    summary: "一位即将退休的老医生，在人生最后一个夜班里，重新走遍了整栋病栋。",
    synopsis:
      "从医四十年的老医生在退休前被安排值最后一次夜班。这一晚，他按照习惯一间间查房，也一间间回忆起住在这里的病人与自己之间的故事：有被误诊后仍选择原谅他的老人，有他没能救回来的年轻人，也有因为他的一句话而重新振作的家属。影片结构舒缓，几乎全部依靠独白与细微的表演推进，在悬疑外壳之下，讲的其实是一个医生与自己一生和解的过程。"
  },
  {
    id: "glass-ward",
    title: "玻璃病栋",
    originalTitle: "The Glass Ward",
    type: "电视剧",
    genres: ["剧情", "犯罪"],
    region: "中国",
    year: 2021,
    duration: "全14集",
    director: "陆文轩",
    cast: ["韩志远", "周雨桐", "赵启明"],
    rating: 8.2,
    views: 88700,
    tags: ["私立医院", "利益", "黑幕", "调查"],
    cover: "https://readdy.ai/api/search-image?query=modern%20glass%20hospital%20building%20reflecting%20night%20sky%2C%20cold%20blue%20tones%2C%20thriller%20poster%2C%20sharp%20geometric%20architecture%2C%20dramatic%20lighting%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-10&orientation=portrait",
    summary: "在一栋全玻璃幕墙的私立医院里，越透明的地方，越藏得住秘密。",
    synopsis:
      "记者程亦舟为调查一起患者投诉，潜入一家以『全透明管理』为卖点的私立医院。玻璃幕墙让每个角落看起来都公开透明，但它同样意味着，所有人都在被观看，也都在表演。随着调查推进，一条涉及药品采购、数据造假与责任推诿的利益链条逐渐显形。剧集用十四集篇幅，把医疗商业化的复杂性拆解得冷静而清晰，也保留了体制内仍有人坚持底线的希望感。"
  },
  {
    id: "white-night-ward",
    title: "白夜病房",
    originalTitle: "White Night Ward",
    type: "电影",
    genres: ["剧情", "悬疑"],
    region: "韩国",
    year: 2020,
    duration: "109分钟",
    director: "朴振浩",
    cast: ["金敏书", "李尚勋"],
    rating: 7.8,
    views: 51300,
    tags: ["病房", "记忆", "昏迷", "真相"],
    cover: "https://readdy.ai/api/search-image?query=white%20hospital%20bed%20in%20a%20dark%20room%20lit%20by%20moonlight%20through%20blinds%2C%20minimal%20cinematic%20composition%2C%20cold%20blue%20palette%2C%20still%20and%20quiet%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-11&orientation=portrait",
    summary: "昏迷七年的病人突然苏醒，而她记得的最后一件事，是有人拔掉了她的输液管。",
    synopsis:
      "一名昏迷了七年的病人在某个深夜毫无征兆地苏醒。她只记得自己入院前的最后一段记忆，以及昏迷期间断断续续听见的对话。为了确认自己不是在做梦，她开始悄悄记录每一个夜班来访者的言行。影片以病床这一极小的空间为舞台，把大量信息压缩在对话与声音设计之中，让观众与主角一同在真假难辨的记忆里寻找唯一可信的那条线索。"
  },
  {
    id: "surgery-3am",
    title: "凌晨三点的手术",
    originalTitle: "The 3AM Surgery",
    type: "电影",
    genres: ["惊悚", "医疗", "犯罪"],
    region: "美国",
    year: 2024,
    duration: "115分钟",
    director: "David Coleman",
    cast: ["Ryan Pierce", "Grace Lin", "Marcus Hale"],
    rating: 8.5,
    views: 117600,
    tags: ["手术室", "倒计时", "劫持", "密闭空间"],
    cover: "https://readdy.ai/api/search-image?query=operating%20room%20at%20three%20am%20with%20wall%20clock%2C%20tense%20cinematic%20lighting%2C%20blue%20teal%20tones%2C%20medical%20thriller%20poster%2C%20surgical%20instruments%2C%20no%20text%2C%20photographic&width=600&height=900&seq=nightward-cover-12&orientation=portrait",
    summary: "凌晨三点，手术室被反锁，门外的人只留下一个条件：这台手术必须失败。",
    synopsis:
      "一支夜班手术团队正在进行一台高难度的心脏手术时，手术室的门突然被人从外部反锁，通讯被切断。门外传来唯一的声音：他们不想让这台手术成功。在不间断的手术台前，主刀医生必须在维持患者生命与应对门外威胁之间走钢丝。影片将密闭空间的压迫感与医疗过程的专业性结合得恰到好处，120分钟的倒计时结构几乎不给观众任何喘息的机会。"
  }
];

export const keywordSuggestions = [
  "夜勤病栋",
  "夜班医生",
  "旧病栋",
  "医疗事故",
  "深夜急诊",
  "手术室"
];